import { useState, type FormEvent } from "react";
import { Link, useNavigate } from "react-router-dom";
import { quickKeywords } from "@/mocks/home";

export default function SearchStrip() {
  const [keyword, setKeyword] = useState("");
  const navigate = useNavigate();

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const value = keyword.trim();
    navigate(value ? `/search?q=${encodeURIComponent(value)}` : "/search");
  };

  return (
    <section className="relative z-30 bg-background-100 pt-5 md:pt-7">
      <div className="container-page">
        <div className="rounded-lg border border-background-200/80 bg-background-50 p-4 md:p-5">
          <form onSubmit={handleSubmit} className="flex flex-col gap-3 sm:flex-row sm:items-center">
            <div className="flex flex-1 items-center gap-3 rounded-md border border-background-300/70 bg-background-100 px-4 py-3 transition-colors focus-within:border-primary-400">
              <i className="ri-search-line text-lg text-foreground-500" aria-hidden="true"></i>
              <input
                type="search"
                value={keyword}
                onChange={(event) => setKeyword(event.target.value)}
                placeholder="输入作品名、类型或关键字，例如「夜行列车」「悬疑」"
                aria-label="搜索影视作品与资讯"
                className="w-full bg-transparent text-sm text-foreground-900 outline-none placeholder:text-foreground-400"
              />
            </div>
            <button
              type="submit"
              className="inline-flex shrink-0 cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-600 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-700"
            >
              <i className="ri-compass-3-line" aria-hidden="true"></i>
              开始检索
            </button>
          </form>
          <div className="mt-3 flex flex-wrap items-center gap-2">
            <span className="text-[11px] text-foreground-500">热门检索：</span>
            {quickKeywords.map((keywordItem) => (
              <Link
                key={keywordItem}
                to={`/search?q=${encodeURIComponent(keywordItem)}`}
                className="rounded-full border border-background-200 bg-background-100 px-3 py-1 text-[11px] text-foreground-700 transition-colors hover:border-accent-300 hover:bg-accent-50 hover:text-accent-800"
              >
                {keywordItem}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}